export enum CookieName {
    COOKIE = 'EduAppCookie'
}
